var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fghotj"},[_c('sub-title',{attrs:{"text":"热点方案推荐"}}),_c('ul',_vm._l((6),function(item){return _c('li',{key:item,staticClass:"ellipsis"},[_vm._v(" 我于2018年3月份入职我们公司 ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }